import React, {Fragment} from 'react'
import {Route} from '../components/Router'
import {Navigation} from '../components/Navigation'

import {Browser, Editor} from '../components/stories';

export default function StaticfilesContainer(){
    return (
        <Fragment>
            <Route path="/stories/" exact={true} component={Browser} />
            <Route path="/stories/:id/:draftId" exact={true} component={Editor} />
        </Fragment>
    )
}